export default {
    scrollOffset: 100
}